import { contractStates } from '../../constants';
const opts = {
  filterable: true,
  sortable: false
};
export default {
  id: 'companyContract.calculatedContractState',
  name: 'companyContract.calculatedContractState',
  displayName: 'Calculated Contract State',
  valueType: 'string',
  objectType: 'companyContract',
  blueprint: {},
  getOption: key => {
    return opts[key];
  },
  get: obj => {
    const now = new Date();
    const startDate = new Date(obj?.data?.contractStartDate);
    const endDate = new Date(obj?.data?.contractEndDate);
    if (now < startDate) {
      return contractStates.scheduled;
    }
    if (now >= startDate && now <= endDate) {
      return contractStates.active;
    }
    if (now > endDate) {
      return contractStates.archived;
    }
    return null;
  }
};